import { Button } from "shared/ui/button";
import { EventRegistrationModal } from "features";
import { EventRegistrationButton } from "features";
import { useModal } from "shared/ui/modal";
import EventHeroImg from "../assets/EventHeroImg.png";
import styles from "./EventHeroSection.module.scss";

export const EventHeroSection = () => {
  const {
    isModalOpen: isEventRegistrationModalOpen,
    open: openEventRegistrationModal,
    close: closeEventRegistrationModal,
    toggle: toggleEventRegistrationModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.heroSection}>
        <div className={styles.infoBlock}>
          <Button variant="outlineWhite" size="medium" disabled={true}>
            28 мая 2026 года г. Самара
          </Button>
          <div className={styles.infoBlock__topBlock}>
            <div>
              <p className={styles.infoBlock__titleBold}>АЗБУКА РУБЦОВ</p>
              <p className={styles.infoBlock__titleThin}>ЛЕЧЕНИЕ ОТ А ДО Я</p>
            </div>
            <p className={styles.infoBlock__text}>
              Авторские протоколы, практические кейсы, разбор клинических
              случаев по работе с рубцами от лучших экспертов
            </p>
          </div>
          <div className={styles.infoBlock__buttonBlock}>
            <div className={styles.infoBlock__button}>
              <EventRegistrationButton
                variant="primaryWhite"
                openModal={openEventRegistrationModal}
              />
            </div>
          </div>
        </div>
        <div className={styles.imageBlock}>
          <img
            src={EventHeroImg}
            className={styles.imageBlock__img}
            alt="EventHeroImg"
          />
        </div>
      </div>
      <EventRegistrationModal
        isModalOpen={isEventRegistrationModalOpen}
        open={openEventRegistrationModal}
        close={closeEventRegistrationModal}
        toggle={toggleEventRegistrationModal}
      />
    </>
  );
};
